import type { TrackInfo } from '../core/types';

/** CSS colour (theme token) for a track's legend swatch. */
export function trackColor(t: TrackInfo): string {
  if (t.kind === 'drums') return 'var(--drums)';
  return `var(--v${(t.voice ?? 0) + 1})`;
}

export function formatTime(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = sec - m * 60;
  return `${m}:${s.toFixed(1).padStart(4, '0')}`;
}

export function download(name: string, data: Uint8Array | string, type: string) {
  const blob = new Blob([data as BlobPart], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function hex(v: number, digits = 2): string {
  return '$' + v.toString(16).toUpperCase().padStart(digits, '0');
}

export const SID_REG_NAMES = [
  'V1 FREQ LO',
  'V1 FREQ HI',
  'V1 PW LO',
  'V1 PW HI',
  'V1 CTRL',
  'V1 AD',
  'V1 SR',
  'V2 FREQ LO',
  'V2 FREQ HI',
  'V2 PW LO',
  'V2 PW HI',
  'V2 CTRL',
  'V2 AD',
  'V2 SR',
  'V3 FREQ LO',
  'V3 FREQ HI',
  'V3 PW LO',
  'V3 PW HI',
  'V3 CTRL',
  'V3 AD',
  'V3 SR',
  'FC LO',
  'FC HI',
  'RES/FILT',
  'MODE/VOL',
];
